import { sfAnd, sfIsNull } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeWdpVersionCodeFilter = (searchValue: string): string =>
    sfAnd([sfLike('versionCode', `${escapeSfqbString(searchValue, true)}*`, true), sfIsNull('dimr.id')]).toString();
